import { Collapse as MantineCollapse, CollapseProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedCollapseProps extends CollapseProps {
  // Add any custom themed props here if needed
}

const Collapse = forwardRef<HTMLDivElement, ThemedCollapseProps>(
  ({ children, ...rest }, ref) => {
    return (
      <MantineCollapse ref={ref} {...rest}>
        {children}
      </MantineCollapse>
    );
  }
);

Collapse.displayName = 'Collapse';

export default Collapse;
